import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardIndexComponent } from './components/inside/dashboard/dashboard-index/dashboard-index.component';
import { InsideComponent } from './components/inside/inside.component';
import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { RecoverComponent } from './components/recover/recover.component';
import { AuthGuardService } from './services/auth-guard/auth-guard.service';
import { ChangePswComponent } from './components/change-psw/change-psw.component';
import { InvoicesComponent } from './components/inside/invoices/invoices.component';
import { UsersComponent } from './components/inside/users/users.component';
import { ConfigurationComponent } from './components/inside/configuration/configuration.component';
import { StatsComponent } from './components/inside/stats/stats.component';
import { UserEditorComponent } from './components/inside/users/user-editor/user-editor.component';
import { RubricaEditorComponent } from './components/inside/configuration/rubrica/rubrica-editor/rubrica-editor.component';
import { EditorInvoiceComponent } from './components/inside/invoices/editor-invoice/editor-invoice.component';
import { ProfileComponent } from './components/profile/profile.component';
import { RegistrazioneComponent } from './components/registrazione/registrazione.component';
import { OptimaSmartComponent } from './components/inside/optima-smart/optima-smart.component';

const routes: Routes = [ 
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'Login',
    component: LoginComponent
  },
  {
    path: 'Register',
    component: RegistrazioneComponent
  },
  {
    path: 'changepwd',
    component: ChangePswComponent
  },
  {
    path: 'recover',
    component: RecoverComponent
  },
  {
    path: 'OptimaSmart',
    component: OptimaSmartComponent,
    canActivate : [AuthGuardService] 
  },
  {
    path: 'main',
    component: InsideComponent,
    children:[
      
      { path: "dashboard", component: DashboardIndexComponent, canActivate : [AuthGuardService] },      
      {
        path: "invoices",
        children: [
          {path: '', pathMatch: 'full', component: InvoicesComponent, canActivate : [AuthGuardService] },
          {path: ':operation', component: EditorInvoiceComponent, canActivate : [AuthGuardService] },
        ]
      },
      {
        path: "users",
        children: [
          {path: '', pathMatch: 'full', component: UsersComponent, canActivate : [AuthGuardService] },
          {path: ':id', component: UserEditorComponent, canActivate : [AuthGuardService] },
        ]
      },
      {
        path: "configuration", 
        canActivate : [AuthGuardService],
        children : [
          {path: "", pathMatch: 'full', component: ConfigurationComponent, canActivate : [AuthGuardService] },
          {path: ":id", component: ConfigurationComponent, canActivate : [AuthGuardService] },
          {path: "addressbook/:id", component: RubricaEditorComponent, canActivate : [AuthGuardService] },
        ]
      },
      {
        path: "stats", 
        component: StatsComponent, 
        canActivate : [AuthGuardService] 
      },
      {
        path: "profile", 
        component: ProfileComponent, 
        canActivate : [AuthGuardService] 
      }
    ]
  },
  {
    path: 'conservazione',
    loadChildren: () => import('./features/conservazione/conservazione-module').then(m => m.ConservazioneModule)
  },
  {
    path: 'archoptima',
    loadChildren: () => import('./features/archoptima/archoptima-module').then(m => m.ArchoptimaModule)
  },
  {
    path: 'amministrazione',
    loadChildren: () => import('./features/amministrazione/amministrazione-module').then(m => m.AmministrazioneModule)
  },
  {
    path:'changelog.txt',
    redirectTo : '../einv7/changelog.txt'
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
